import * as React from 'react';
import * as s from './PortfolioSelect.module.scss';
import { PortfolioContext } from '../../../../context/PortfolioContext';

interface Props {
  options: string[];
  type: 'responsibility' | 'location';
  className?: string;
}

interface PortfolioState {}

export class PortfolioSelect extends React.Component<Props, PortfolioState> {
  selectRef = React.createRef<HTMLSelectElement>();
  static contextType = PortfolioContext;

  onChange = () => {
    const {
      setLocationFilter,
      setResponsibilityFilter,
      resetResponsibilityFilter,
      resetLocationFilter,
    } = this.context;
    const { type } = this.props;
    const selectedValue = this.selectRef.current.value;

    if (type === 'responsibility') {
      if (selectedValue === 'All responsibilities') {
        resetResponsibilityFilter();
      } else {
        setResponsibilityFilter(selectedValue);
      }
    } else {
      if (selectedValue === 'All locations') {
        resetLocationFilter();
      } else {
        setLocationFilter(selectedValue);
      }
    }
  };

  render() {
    const { options, className, type } = this.props;
    const selectClasses = [s.select];

    if (className) {
      selectClasses.push(className);
    }

    let allOption =
      type === 'responsibility' ? 'All responsibilities' : 'All locations';

    return (
      <div className={`col-md-6 ${s.selectWrapper}`}>
        <select
          onChange={this.onChange}
          ref={this.selectRef}
          className={selectClasses.join(' ')}
        >
          <option>{allOption}</option>
          {options.map((option, i) => (
            <option key={i}>{option}</option>
          ))}
        </select>
      </div>
    );
  }
}
